import { createAsyncThunk } from '@reduxjs/toolkit';

import { goodsService } from '@/services';
import { handleThunkApiError } from '@/utils';

export const getRelatedProducts = createAsyncThunk(
  'goods/get-related-products',
  handleThunkApiError(goodsService.getRelatedProducts),
);
